module.exports = __webpack_public_path__ + "img/8862712.png";